import React, { Component } from "react"
import Typography from "@mui/material/Typography"
import IconButton from "@mui/material/IconButton"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemText from "@mui/material/ListItemText"
import Grid from "@mui/material/Grid"
import Zoom from "@mui/material/Zoom"
import Fab from "@mui/material/Fab"
import Celebration from "@mui/icons-material/CelebrationOutlined"
import CircularProgress from "@mui/material/CircularProgress"
import Link from "@mui/icons-material/Link"
import Logout from "@mui/icons-material/Logout"
import ChevronLeft from "@mui/icons-material/ChevronLeft"
import ChevronRight from "@mui/icons-material/ChevronRight"
import Refresh from "@mui/icons-material/Refresh"
import { Client } from "@hapi/nes/lib/client"
import Measure from "react-measure"
import queryStringify from "querystringify"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import Helmet from "react-helmet"
import moment from "moment"
import clipboardCopy from "clipboard-copy"
import UserRoom from "../user/UserRoom"
import { secondsToTime } from "../utilities"

export default withTranslation()(
  withRouter(
    class AdminRoom extends Component {
      state = {
        nextPageWidth: null,
        selectedTab: 0,
        loading: false,
        room: null,
        timer: null,
        confetti: false,
        confettiTriggered: null,
      }

      resetTimer = async (experience, room) => {
        await fetch(
          `${
            process.env.REACT_APP_SERVER_URL
          }/experiences/${experience}/rooms/${room}/resetTimer?password=${localStorage.getItem(
            "password"
          )}`,
          {
            method: "POST",
            headers: {},
          }
        ).then(
          this.setState({
            timer: 0,
          })
        )
      }

      setTimer = (room) => {
        if (room?.timerStartDate) {
          this.setState({
            timer: room.timerEndDate
              ? moment(room.timerEndDate).diff(
                  moment(room.timerStartDate),
                  "seconds"
                )
              : moment().diff(moment(room.timerStartDate), "seconds"),
          })

          let interval = setInterval(() => {
            //get timerEndDate from state in order to stop the timer when a timer subscription arrives
            if (
              !this.state.room.timerEndDate &&
              this.state.room.timerStartDate
            ) {
              this.setState({
                timer: moment().diff(moment(room.timerStartDate), "seconds"),
              })
            } else {
              clearInterval(interval)
            }
          }, 1000)
        }
      }

      fetchRoom = async () => {
        if (!this.fetchRoom.locked) {
          this.fetchRoom.locked = true

          if (!this.state.room) {
            this.setState({ loading: true })
          }

          let room = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/experiences/${
              queryStringify.parse(window.location.search).experience
            }/rooms/${
              queryStringify.parse(window.location.search).room
            }?password=${localStorage.getItem("password")}`
          )
            .then(async (response) => {
              if (response.status !== 200) {
                return null
              }

              const client = new Client(
                process.env.REACT_APP_SERVER_URL.replace("https", "wss")
              )

              const start = async () => {
                await client.connect()

                client.subscribe("/room/" + room.roomCode, (payload) => {
                  if (room.timerStartDate !== payload.timerStartDate) {
                    this.setTimer(payload)
                  }

                  if (payload.confetti) {
                    this.setState({ confetti: true })
                  }

                  this.setState(({ room, selectedTab }) => ({
                    room: { ...room, ...payload },
                    selectedTab:
                      payload.currentSlide &&
                      room.experience.slides[payload.currentSlide].tipo !==
                        "domanda-aperta" &&
                      room.experience.slides[payload.currentSlide].tipo !==
                        "domanda-a-risposta-multipla"
                        ? 0
                        : selectedTab,
                  }))
                })
              }

              start()

              return await response.json()
            })
            .catch(() => null)

          if (room) {
            if (room.timerStartDate) {
              this.setTimer(room)
            } else {
              this.setState({ timer: 0 })
            }
          }

          this.setState({ room, loading: false })

          this.fetchRoom.locked = false
        }
      }

      previousSlide = async (experience, room) => {
        await fetch(
          `${
            process.env.REACT_APP_SERVER_URL
          }/experiences/${experience}/rooms/${room}/previousSlide?password=${localStorage.getItem(
            "password"
          )}`,
          {
            method: "POST",
            headers: {},
          }
        )
      }

      nextSlide = async (experience, room) => {
        await fetch(
          `${
            process.env.REACT_APP_SERVER_URL
          }/experiences/${experience}/rooms/${room}/nextSlide?password=${localStorage.getItem(
            "password"
          )}`,
          {
            method: "POST",
            headers: {},
          }
        )
      }

      componentDidMount() {
        this.fetchRoom()
      }

      render() {
        const { history, t } = this.props
        const {
          nextPageWidth,
          selectedTab,
          loading,
          room,
          timer,
          confetti,
          confettiTriggered,
        } = this.state

        if (confettiTriggered) {
          setTimeout(
            () => this.setState({ confettiTriggered: false }),
            //5000 is the duration of the confetti animation, 225 is the duration of the FAB zoom transition
            5000 - 225
          )
        }

        return (
          <>
            <Helmet>
              <title>
                Lapwing
                {room ? ` - ${room.experience.name} (${room.company})` : ""}
              </title>
            </Helmet>
            <div
              style={{ height: "100%", backgroundColor: "#E6E2B1" }}
              className="notSelectable"
            >
              <div
                style={{
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    width: "180px",
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "20px",
                  }}
                >
                  <IconButton
                    style={{
                      color: "#181818",
                      opacity: room ? 1 : 0.54,
                    }}
                    onClick={() =>
                      this.resetTimer(
                        queryStringify.parse(window.location.search).experience,
                        queryStringify.parse(window.location.search).room
                      )
                    }
                    disabled={!room}
                  >
                    <Refresh />
                  </IconButton>
                  {timer !== null && (
                    <Typography
                      variant="h6"
                      style={{
                        fontWeight: 600,
                        color: "#181818",
                        marginLeft: "16px",
                      }}
                    >
                      {secondsToTime(timer)}
                    </Typography>
                  )}
                </div>
                <Typography
                  variant="h5"
                  style={{
                    width: "calc(100% - 328px)",
                    fontWeight: 600,
                    color: "#181818",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    margin: "0 16px",
                    textAlign: "center",
                  }}
                >
                  {room ? `${room.experience.name} - ${room.company}` : null}
                </Typography>
                <div
                  style={{
                    width: "180px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                    marginRight: "20px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      whiteSpace: "nowrap",
                      fontWeight: 600,
                      color: "#181818",
                      marginRight: "16px",
                      WebkitTouchCallout: "text",
                      WebkitUserSelect: "text",
                      KhtmlUserSelect: "text",
                      MozUserSelect: "text",
                      MsUserSelect: "text",
                      userSelect: "text",
                    }}
                  >
                    {room?.roomCode
                      ? room.roomCode
                          .toString()
                          .padStart(6, 0)
                          .toString()
                          .slice(0, -3) +
                        "-" +
                        room.roomCode
                          .toString()
                          .padStart(6, 0)
                          .toString()
                          .substr(-3)
                      : ""}
                  </Typography>
                  <IconButton
                    style={{
                      color: "#181818",
                      opacity: room ? 1 : 0.54,
                    }}
                    onClick={() =>
                      clipboardCopy(
                        window.location.origin +
                          "/?experience=" +
                          room.experience.id +
                          "&room=" +
                          room.roomCode
                      )
                    }
                    disabled={!room}
                  >
                    <Link />
                  </IconButton>
                  <IconButton
                    style={{ color: "#181818" }}
                    onClick={() =>
                      history.push(
                        "/admin?experience=" +
                          queryStringify.parse(window.location.search)
                            .experience
                      )
                    }
                  >
                    <Logout />
                  </IconButton>
                </div>
              </div>
              <div
                style={{
                  height: "calc(100% - 80px)",
                  backgroundColor: "white",
                  boxShadow: "0px -4px 12px rgba(0, 0, 0, 0.25)",
                }}
              >
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <CircularProgress />
                  </div>
                ) : room ? (
                  <Grid container style={{ height: "100%", paddingTop: "8px" }}>
                    <Grid
                      item
                      xs={8}
                      style={{ height: "100%", padding: "0 8px 16px 16px" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "64px",
                        }}
                      >
                        <IconButton
                          style={{
                            color: "black",
                            opacity: room.currentSlide === 0 ? 0.54 : 1,
                          }}
                          onClick={() =>
                            this.previousSlide(
                              queryStringify.parse(window.location.search)
                                .experience,
                              queryStringify.parse(window.location.search).room
                            )
                          }
                          disabled={room.currentSlide === 0}
                        >
                          <ChevronLeft />
                        </IconButton>
                        <Typography
                          variant="h6"
                          style={{
                            fontWeight: 600,
                            margin: "0 8px",
                          }}
                        >
                          {t`Page` +
                            " " +
                            (room.currentSlide + 1) +
                            " " +
                            t`of` +
                            " " +
                            room.experience.slides.length}
                        </Typography>
                        <IconButton
                          style={{
                            color: "black",
                            opacity:
                              room.currentSlide + 1 ===
                              room.experience.slides.length
                                ? 0.54
                                : 1,
                          }}
                          onClick={() =>
                            this.nextSlide(
                              queryStringify.parse(window.location.search)
                                .experience,
                              queryStringify.parse(window.location.search).room
                            )
                          }
                          disabled={
                            room.currentSlide + 1 ===
                            room.experience.slides.length
                          }
                        >
                          <ChevronRight />
                        </IconButton>
                      </div>
                      <Measure bounds>
                        {({
                          measureRef,
                          contentRect: {
                            bounds: { width, height },
                          },
                        }) => (
                          <div
                            style={{
                              height: "calc(100% - 64px)",
                              position: "relative",
                              overflow: "hidden",
                              // position: "relative" is needed to have hotspots be centered relative to parent rather than window
                            }}
                            ref={measureRef}
                          >
                            <UserRoom
                              adminRoom={room}
                              parentAspectRatio={width / height}
                              confetti={confetti}
                              setConfetti={(confetti) =>
                                this.setState({ confetti })
                              }
                            />
                          </div>
                        )}
                      </Measure>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      style={{ height: "100%", padding: "0 16px 16px 8px" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "64px",
                        }}
                      >
                        <Typography
                          variant="h6"
                          style={{
                            fontWeight: 600,
                            margin: "0 8px",
                          }}
                        >
                          {t`Next page`}
                        </Typography>
                      </div>
                      <Measure
                        bounds
                        onResize={(contentRect) => {
                          this.setState({
                            nextPageWidth: contentRect.bounds.width,
                          })
                        }}
                      >
                        {({ measureRef }) =>
                          room.currentSlide + 1 <
                          room.experience.slides.length ? (
                            <UserRoom
                              measureRef={measureRef}
                              adminRoom={{
                                ...room,
                                currentSlide: room.currentSlide + 1,
                              }}
                              isNextPage
                              nextPageHeight={(nextPageWidth * 9) / 16}
                            />
                          ) : (
                            <div
                              style={{
                                widht: "100%",
                                height: (nextPageWidth * 9) / 16,
                                backgroundColor: "#E6E2B1",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                              ref={measureRef}
                            >
                              <Typography
                                variant="h5"
                                style={{
                                  textAlign: "center",
                                  margin: "0 16px",
                                }}
                              >{t`You are viewing the last page`}</Typography>
                            </div>
                          )
                        }
                      </Measure>
                      <Tabs
                        value={selectedTab}
                        onChange={(_, selectedTab) =>
                          this.setState({ selectedTab })
                        }
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        style={{ marginTop: "16px" }}
                      >
                        <Tab
                          label={
                            t`Partipants` + ` (${room.participants.length})`
                          }
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        />
                        <Tab
                          label={t`Answers`}
                          disabled={
                            (room.experience.slides[room.currentSlide].tipo !==
                              "domanda-aperta" &&
                              room.experience.slides[room.currentSlide].tipo !==
                                "domanda-a-risposta-multipla") ||
                            room.participants.length === 0
                          }
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        />
                      </Tabs>
                      {selectedTab === 0 ? (
                        <List
                          style={{
                            height:
                              "calc(100% - " +
                              (128 + (nextPageWidth * 9) / 16) +
                              "px)",
                            overflow: "auto",
                          }}
                          key="participants"
                        >
                          {room.participants.map(({ name, offline }) => (
                            <ListItem key={name}>
                              <ListItemText
                                primary={name + (offline ? " (offline)" : "")}
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              />
                            </ListItem>
                          ))}
                        </List>
                      ) : (
                        <List
                          style={{
                            height:
                              "calc(100% - " +
                              (128 + (nextPageWidth * 9) / 16) +
                              "px)",
                            overflow: "auto",
                          }}
                          key="answers"
                        >
                          {Object.keys(
                            room.answers[room.currentSlide]
                              ? room.answers[room.currentSlide].reduce(
                                  (acc, { answer: curr }) => {
                                    return (
                                      acc[curr.toLowerCase().trim()]
                                        ? ++acc[curr.toLowerCase().trim()]
                                        : (acc[curr.toLowerCase().trim()] = 1),
                                      acc
                                    )
                                  },
                                  {}
                                )
                              : {}
                          ).map((answer) => (
                            <ListItem key={answer}>
                              <ListItemText
                                primary={answer}
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              />
                              <Typography>
                                {Math.round(
                                  (room.answers[room.currentSlide].reduce(
                                    (acc, { answer: curr }) => {
                                      return (
                                        acc[curr.toLowerCase().trim()]
                                          ? ++acc[curr.toLowerCase().trim()]
                                          : (acc[
                                              curr.toLowerCase().trim()
                                            ] = 1),
                                        acc
                                      )
                                    },
                                    {}
                                  )[answer] /
                                    room.participants.length) *
                                    100
                                ) + "%"}
                              </Typography>
                            </ListItem>
                          ))}
                          {Object.values(
                            room.answers[room.currentSlide]
                              ? room.answers[room.currentSlide].reduce(
                                  (acc, { answer: curr }) => {
                                    return (
                                      acc[curr.toLowerCase().trim()]
                                        ? ++acc[curr.toLowerCase().trim()]
                                        : (acc[curr.toLowerCase().trim()] = 1),
                                      acc
                                    )
                                  },
                                  {}
                                )
                              : {}
                          ).reduce((acc, curr) => acc + curr, 0) !==
                          room.participants.length ? (
                            <ListItem key="unaswered">
                              <ListItemText
                                primary={<em>{t`No Answer`}</em>}
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              />
                              <Typography>
                                {Math.round(
                                  ((room.participants.length -
                                    Object.values(
                                      room.answers[room.currentSlide]
                                        ? room.answers[
                                            room.currentSlide
                                          ].reduce((acc, { answer: curr }) => {
                                            return (
                                              acc[curr.toLowerCase().trim()]
                                                ? ++acc[
                                                    curr.toLowerCase().trim()
                                                  ]
                                                : (acc[
                                                    curr.toLowerCase().trim()
                                                  ] = 1),
                                              acc
                                            )
                                          }, {})
                                        : {}
                                    ).reduce((acc, curr) => acc + curr, 0)) /
                                    room.participants.length) *
                                    100
                                ) + "%"}
                              </Typography>
                            </ListItem>
                          ) : null}
                        </List>
                      )}
                    </Grid>
                  </Grid>
                ) : (
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      textAlign: "center",
                    }}
                  >
                    <Typography
                      variant="h4"
                      style={{
                        fontSize: "30px",
                        fontWeight: 600,
                        margin: "0 32px 8px 32px",
                        color: "#181818",
                      }}
                    >
                      {t`Something went wrong`}
                    </Typography>
                    <Typography
                      variant="h6"
                      style={{
                        fontWeight: 300,
                        margin: "0 32px",
                        color: "#181818",
                      }}
                    >{t`Check your connection and try again`}</Typography>
                  </div>
                )}
              </div>
              <Zoom in={room && !confettiTriggered}>
                <Fab
                  color="primary"
                  style={{
                    position: "absolute",
                    right: "24px",
                    bottom: "24px",
                    backgroundColor: "#181818",
                    color: "white",
                    borderRadius: "16px",
                  }}
                  onClick={() =>
                    fetch(
                      `${process.env.REACT_APP_SERVER_URL}/experiences/${
                        queryStringify.parse(window.location.search).experience
                      }/rooms/${
                        queryStringify.parse(window.location.search).room
                      }/confetti?password=${localStorage.getItem("password")}`,
                      {
                        method: "POST",
                        headers: {},
                      }
                    ).then(() => this.setState({ confettiTriggered: true }))
                  }
                >
                  <Celebration />
                </Fab>
              </Zoom>
            </div>
          </>
        )
      }
    }
  )
)
